module.exports = __webpack_public_path__ + "img/game02.5378a3ae.png";